export * from './ClockLoaderStyles';